import React, { FC } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { GroupWrap } from 'components/group-wrap/group-wrap';
import { SubjectIcon } from 'components/subject-icon/SubjectIcon';
import { getSubjectIcon } from 'assets/icons/subjects/subject-icons';
import { Text } from 'components/text/Text';
import {
  getSubjectsByNumber,
} from 'logic/store/subject/subject.selectors';
import { getSubjectNameWithSoftHyphens } from 'logic/store/subject/subject.logic';
import { FormFieldSubject } from 'components/form-fields/form-field-subject/form-field-subject';
import { OfferFormFields } from '../offer-form.logic';
import { HeadingPublishOffer } from './common';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { SubjectSelectOption } from 'logic/store/subject/subject.model';

const SubjectsSelectContainer = styled.div`
  .ant-form-item-label
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    display: none;
  }
  .ant-form-item {
    margin: 0;
  }
`;

interface SubjectsSelectProps {
  selectedSubjects: number[] | undefined;
  heading?: string;
  label: string;
  storeSubjectOptions?: SubjectSelectOption[];
}

export const SubjectsSelect: FC<SubjectsSelectProps> = ({ heading, label, selectedSubjects, storeSubjectOptions }) => {
  const subjectsByNumber = useSelector(getSubjectsByNumber);

  return (
    <SubjectsSelectContainer>
      <HeadingPublishOffer level={2}>{heading}</HeadingPublishOffer>
      <FormFieldSubject
        name={OfferFormFields.subjects}
        mode={'multiple'}
        label={<Text size={14}>{label}</Text>}
        placeholder={translate(translationKeys.publishOffer.subjects.placeholder)}
        subjectOptions={storeSubjectOptions}
      />

      <div style={{ marginTop: '20px', width: '100%' }}>
        <GroupWrap gap={0}>
          {selectedSubjects?.map((subjectNumber, index) => {
            const subjectIcon = getSubjectIcon(subjectNumber);
            const subjectName = getSubjectNameWithSoftHyphens(subjectsByNumber, subjectNumber);
            return (
              <div key={index}>
                <SubjectIcon icon={subjectIcon} text={subjectName} isTextSafeAsHTML />
              </div>
            );
          })}
        </GroupWrap>
      </div>
    </SubjectsSelectContainer>
  );
};
